import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
// TODO
// import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { selectLastSelectedTableRow } from 'services/selectedTableCells/selectors';

// Component Types
import { ConnectedProps, Props } from './types';

/**
 * Finds a table row with an id that matches the selectedTableRowId and scrolls to it
 */
export class ScrollToSelectedTableRow extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { selectedTableRowId } = this.props;

        if (selectedTableRowId) {
            // Wrapped in setTimeout to make sure that table has been rendered
            setTimeout((): void => {
                // Find corresponding row and scroll to it
                const contentElement = document.getElementById('content');
                const rowElement = document.getElementById(selectedTableRowId);
                const tableHeaderHeight = 36;

                if (contentElement && rowElement) {
                    contentElement.scrollTo(
                        0,
                        rowElement.offsetTop - tableHeaderHeight
                    );
                }
            }, 1);
        }
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    any, // TODO replace with AppState
    {},
    ConnectedProps
>({
    selectedTableRowId: selectLastSelectedTableRow
});

export default connect(mapStateToProps)(ScrollToSelectedTableRow);
